export class Design
{
    public readonly id:number;
    public readonly projectId:number;
    public readonly name:string;
    public readonly description:string;
    public readonly designerState:string;
    public readonly isGuide:boolean;
    public readonly removed:boolean;
    public readonly backupDesignerState:string;
    public readonly version:number;
    public readonly changedBy:number;
    public readonly changedInSession:number;
    public readonly uuid:string;
    public readonly orderIndex:number;
    public readonly multiplayerConnectHostname:string;
    public readonly multiplayerLockAcquirerUuid:string;
    public readonly multiplayerLockAcquiredAt:number;

    constructor(json:any)
    {
        this.id = json['id'];
        this.projectId = json['projectId'];
        this.name = json['name'];
        this.description = json['description'];
        this.designerState = json['designerState'];
        this.isGuide = json['isGuide'];
        this.removed = json['removed'];
        this.backupDesignerState = json['backupDesignerState'];
        this.version = json['version'];
        this.changedBy = json['changedBy'];
        this.changedInSession = json['changedInSession'];
        this.uuid = json['uuid'];
        this.orderIndex = json['orderIndex'];
        this.multiplayerConnectHostname = json['multiplayerConnectHostname'];
        this.multiplayerLockAcquirerUuid = json['multiplayerLockAcquirerUuid'];
        this.multiplayerLockAcquiredAt = json['multiplayerLockAcquiredAt'];
    }
}
